/* eslint-disable no-restricted-globals */
import * as helpers from '@turf/helpers';

import { unionMapWaterPolygons } from '../map/utils/helpers/mapWaterLayerUtils';

self.onmessage = (
  event: MessageEvent<
    helpers.Feature<helpers.Polygon, helpers.Properties>[] | null
  >,
) => {
  self.postMessage(unionMapWaterPolygons(event.data));
};

export {};
